import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { setUser } from "../actions/userAction";
import { setHeaderMenus } from "../actions/headerrAction";
import { useNavigate, Link } from "react-router-dom";
import "../css/login.css";
import axios from "axios";
import API_BASE_URL from "../config";
import { ToastContainer, toast, Zoom } from "react-toastify";

if (typeof window !== "undefined") {
  require("react-toastify/dist/ReactToastify.css");
}

const Login = ({ setUser, setHeaderMenus }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.",{
        transition: Zoom,
        autoClose: 2000,
        theme: "dark",
      });
      return;
    }

    if (!password) {
      toast.error("Password is required.",{
        transition: Zoom,
        autoClose: 2000,
        theme: "dark",
      });
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/login`,
        { email, password },
        { withCredentials: true }
      );

      const data = response.data;

      // Store user in Redux
      setUser({
        id: data.user_id,
        email: data.email,
        username: data.username,
        role: data.role,
      });

      // Fetch header menus
      const menuRes = await axios.get(`${API_BASE_URL}/api/headerMenus`, {
        withCredentials: true,
      });

      setHeaderMenus(menuRes.data.headerMenus);

      // Redirect to homepage
      navigate("/");
    } catch (error) {
      if (error.response && error.response.data?.message) {
        toast.error(error.response.data.message, {
          transition: Zoom,
          autoClose: 2000,
          theme: "dark",
        });
      } else {
        console.error("Login Error:", error);
        toast.error("An error occurred. Please try again.", {
          transition: Zoom,
          autoClose: 2000,
          theme: "dark",
        });
      }
    }
  };

  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/check-session`, {
          withCredentials: true,
        });
        const data = response.data;
      
      } catch (error) {
        console.error("Session check failed", error);
      }
    };

    checkSession();
  }, []);

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="loginh2">Sign In</h2>

        <div className="input-wrapper">
          <input
            type="email"
            className="input-box-login"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <label className={email ? "floating filled" : "floating"}>Email ID</label>
        </div>

        <div className="input-wrapper password-wrapper">
  <input
    type={showPassword ? "text" : "password"}
    className="input-box-login"
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    required
  />

  <label className={password ? "floating filled" : "floating"}>
    Password
  </label>

  <span
    className="toggle-password"
    onClick={() => setShowPassword(prev => !prev)}
  >
    {showPassword ? "Hide" : "Show"}
  </span>
</div>
<button className="continue-btn" onClick={handleLogin}>
          Continue
</button>

        <div className="create-account">
          <span>New to Dihan Tech?</span>
          <Link to="/register">Create your account</Link>
        </div>
      </div>

      <ToastContainer hideProgressBar />
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user?.user || null,
});

const mapDispatchToProps = (dispatch) => ({
  setUser: (user) => dispatch(setUser(user)),
  setHeaderMenus: (menus) => dispatch(setHeaderMenus(menus)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);


